(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('emailField', EmailField);

    /** @ngInject */
    function EmailField($rootScope, HelperService, EmailTypeService, PATHS) {
        function EmailFieldController($scope) {
            const vm = this;

            vm.addEmail = () => {
                vm.amountOfEmails++;
            }

            vm.removeEmail = index => {
                vm.emails.splice(index, 1);

                vm.amountOfEmails--;
            }

            vm.getNumber = num => {
                return new Array(num);
            }

            vm.getEmailTypes = () => {
                HelperService.startLoading('.email-container', true);

                return EmailTypeService
                    .getAll()
                    .then(success => {
                        vm.emailTypes = success;
                        HelperService.stopLoading('.email-container')
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.email-container')
                    })
            }

            init();

            function init() {
                vm.emailTypes = [];
                vm.getValidationMessage = $rootScope.ValidationMessage;
            }
        }

        function link(scope, element, attrs, ctrl) {
            ctrl.getEmailTypes()
                .then(() => {
                    ctrl.amountOfEmails = 1;

                    if (ctrl.emails && ctrl.emails.length) {
                        ctrl.amountOfEmails = ctrl.emails.length;
                    } else {
                        if (ctrl.type) {
                            ctrl.emails = [{
                                EmailTypeId: 2
                            }]

                        } else
                            ctrl.emails = [];
                    }

                    if (ctrl.amountOfEmails == 0)
                            ctrl.amountOfEmails = 1;
                })
        }

        return {
            bindToController: true,
            controller: EmailFieldController,
            controllerAs: 'vm',
            link: link,
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/email-field/email-field.html`,
            scope: {
                emails: '=',
                type: '=',
                canEdit: '='
            }
        }
    }
}());